import { IconLink } from "@tabler/icons-react";

import { Text } from "@fragments";

import "./styles.scss";

function normalizeUrl(url) {
    return !url.startsWith("http://") && !url.startsWith("https://")
        ? "https://" + url
        : url;
}

export default function GroupMeta({ description, links }) {
    if (!description && !links?.length) return null;

    return (
        <div className="group-meta">
            {description && (
                <Text.p contrast={6} className="group-meta__description">
                    {description}
                </Text.p>
            )}
            {links?.length > 0 && (
                <div className="group-meta__links">
                    {links.map((link, i) => (
                        <a
                            key={i}
                            href={normalizeUrl(link.url)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="group-link"
                        >
                            <IconLink size={15} />
                            <Text.span>{link.title}</Text.span>
                        </a>
                    ))}
                </div>
            )}
        </div>
    );
}
